import { bdayGet, bdayPost } from "services/utils";

const baseApi = "/api/1/payment";

export const syncMembership = (data) => {
  return bdayGet(`${baseApi}/sync_membership${data ? data : ""}`);
};
export const autoRenew = (data) => {
  return bdayPost(`${baseApi}/auto_renew`, data || {});
};
export const getOffers = (data) => {
  const { search, ...payload } = data;
  return bdayPost(`${baseApi}/offers${search ? search : ""}`, payload);
};
export const adminResetPremium = (data) => {
  return bdayPost(`${baseApi}/admin/reset`, data);
};
export const adminExpirePremium = (data) => {
  return bdayPost(`${baseApi}/admin/expire`, data);
};
